import style from './lista.module.scss';
import Item from "./item";
import { ITarefa } from '../../types/tarefa';

interface Props{
    tarefa: ITarefa[],
    selecionaTarefa: (tarefaSelecionada: ITarefa) => void;
}

function Lista({tarefa, selecionaTarefa}:Props) {
    return (
        <aside className={style.listaTarefas}>
            <h2>Estudo do Dia </h2>
            <ul>
                {tarefa.map(item => (
                    <Item
                    selecionaTarefa={selecionaTarefa}
                    key={item.id}
                        {...item}
                    />
                    ))}
            </ul>
        </aside>
    )
}

export default Lista;